/**
 * World Cup 2026 common static data
 *
 * TEAM_LOGO keys are all lowercase.
 * Multiple aliases are provided for teams with inconsistent naming
 * (e.g. polymarket vs. native-stats vs. FIFA official).
 */

export const TEAM_LOGO: Record<string, string> = {
  // --- North & Central America ---
  // Source: scraped from https://polymarket.com/sports/world-cup/games
  mexico: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Mexico-dca6a00b6d.png',
  'united states':
    'https://polymarket-upload.s3.us-east-2.amazonaws.com/United States-c25fb90a8b.png',
  usa: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/United States-c25fb90a8b.png',
  canada: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Canada-529c24bcfb.png',
  panama: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Panama-796125f96f.png',
  haiti: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Haiti-4d762c9160.png',

  // --- South America ---
  argentina: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Argentina-182153c3dd.png',
  brazil: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Brazil-7b26872c5b.png',
  uruguay: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Uruguay-fa69ff8aeb.png',
  colombia: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Colombia-096627d8a2.png',
  ecuador: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Ecuador-9b4af94758.png',
  paraguay: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Paraguay-df8ca4e644.png',

  // --- Europe ---
  england: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/England-51e34db93c.png',
  france: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/France-e9affbd5a2.png',
  spain: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Spain-7fd7fb20f3.png',
  germany: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Germany-63cabc9f60.png',
  portugal: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Portugal-e594da7f36.png',
  netherlands: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Netherlands-5990c81d39.png',
  belgium: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Belgium-f5040430dd.png',
  austria: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Austria-8ee4b01a98.png',
  sweden: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Sweden-8f153dea44.png',
  norway: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Norway-b87bd7e0b5.png',
  scotland: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Scotland-75425c8075.png',
  croatia: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Croatia-5975b6a3b2.png',
  czechia: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Czechia-973246d97a.png',
  switzerland: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Switzerland-eb3b9b5167.png',
  turkey: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Türkiye-e55f684d53.png',
  türkiye: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Türkiye-e55f684d53.png',

  // --- Africa ---
  'south africa':
    'https://polymarket-upload.s3.us-east-2.amazonaws.com/South Africa-9dd4f78e33.png',
  morocco: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Morocco-8a84f8e56c.png',
  senegal: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Senegal-ad12355764.png',
  algeria: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Algeria-a098432aa7.png',
  tunisia: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Tunisia-ec80d55fec.png',
  egypt: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Egypt-25dade1183.png',
  ghana: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Ghana-5e8015fb06.png',
  "côte d'ivoire":
    "https://polymarket-upload.s3.us-east-2.amazonaws.com/Côte d'Ivoire-829fa69150.png",
  'ivory coast':
    "https://polymarket-upload.s3.us-east-2.amazonaws.com/Côte d'Ivoire-829fa69150.png",
  'dr congo': 'https://polymarket-upload.s3.us-east-2.amazonaws.com/DR Congo-0a32eb7bfe.png',
  'congo dr': 'https://polymarket-upload.s3.us-east-2.amazonaws.com/DR Congo-0a32eb7bfe.png',
  'cabo verde': 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Cabo Verde-6a0b5592c4.png',
  'cape verde': 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Cabo Verde-6a0b5592c4.png',
  'cape verde islands':
    'https://polymarket-upload.s3.us-east-2.amazonaws.com/Cabo Verde-6a0b5592c4.png',

  // --- Asia ---
  japan: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Japan-da1d5dae13.png',
  'korea republic':
    'https://polymarket-upload.s3.us-east-2.amazonaws.com/Korea Republic-de7776cb88.png',
  'south korea':
    'https://polymarket-upload.s3.us-east-2.amazonaws.com/Korea Republic-de7776cb88.png',
  'saudi arabia':
    'https://polymarket-upload.s3.us-east-2.amazonaws.com/Saudi Arabia-591a9a0aa9.png',
  iran: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/IR Iran-d087f60b44.png',
  'ir iran': 'https://polymarket-upload.s3.us-east-2.amazonaws.com/IR Iran-d087f60b44.png',
  iraq: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Iraq-c7b83c3016.png',
  jordan: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Jordan-1a560c81b8.png',
  qatar: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Qatar-dcf5549892.png',
  uzbekistan: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Uzbekistan-dd15744497.png',

  // --- Oceania ---
  australia: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Australia-c124bed048.png',
  'new zealand': 'https://polymarket-upload.s3.us-east-2.amazonaws.com/New Zealand-f5e4e9e65c.png',

  // --- Caribbean / Other ---
  curaçao: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Curaçao-3b1e3eecd4.png',
  curacao: 'https://polymarket-upload.s3.us-east-2.amazonaws.com/Curaçao-3b1e3eecd4.png',
  'bosnia and herzegovina':
    'https://polymarket-upload.s3.us-east-2.amazonaws.com/Bosnia-Herzegovina-868e929209.png',
  'bosnia-herzegovina':
    'https://polymarket-upload.s3.us-east-2.amazonaws.com/Bosnia-Herzegovina-868e929209.png',
};

/**
 * Look up a team logo URL by name (case-insensitive).
 * Returns null if not found.
 */
export function getTeamLogo(teamName: string): string | null {
  return TEAM_LOGO[teamName.toLowerCase()] ?? null;
}

export type WorldCup2026GroupKey =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H'
  | 'I'
  | 'J'
  | 'K'
  | 'L';

export interface WorldCup2026TeamGroupInfo {
  group: WorldCup2026GroupKey;
  zhName: string;
  enName: string;
  aliases: string[];
}

export const WORLD_CUP_2026_GROUP_TEAMS: Record<WorldCup2026GroupKey, WorldCup2026TeamGroupInfo[]> =
  {
    A: [
      { group: 'A', zhName: '墨西哥', enName: 'Mexico', aliases: ['mex', 'Mexico'] },
      { group: 'A', zhName: '南非', enName: 'South Africa', aliases: ['rsa', 'South Africa'] },
      {
        group: 'A',
        zhName: '韩国',
        enName: 'Korea Republic',
        aliases: ['kor', 'kr', 'Korea Republic', 'South Korea', 'Korea'],
      },
      {
        group: 'A',
        zhName: '捷克',
        enName: 'Czechia',
        aliases: ['cze', 'Czechia', 'Czech Republic'],
      },
    ],
    B: [
      { group: 'B', zhName: '加拿大', enName: 'Canada', aliases: ['can', 'Canada'] },
      {
        group: 'B',
        zhName: '波黑',
        enName: 'Bosnia and Herzegovina',
        aliases: ['bih', 'Bosnia and Herzegovina', 'Bosnia-Herzegovina', 'Bosnia'],
      },
      { group: 'B', zhName: '卡塔尔', enName: 'Qatar', aliases: ['qat', 'Qatar'] },
      { group: 'B', zhName: '瑞士', enName: 'Switzerland', aliases: ['che', 'Switzerland'] },
    ],
    C: [
      { group: 'C', zhName: '巴西', enName: 'Brazil', aliases: ['bra', 'Brazil'] },
      { group: 'C', zhName: '摩洛哥', enName: 'Morocco', aliases: ['mar', 'Morocco'] },
      { group: 'C', zhName: '海地', enName: 'Haiti', aliases: ['hai', 'Haiti'] },
      { group: 'C', zhName: '苏格兰', enName: 'Scotland', aliases: ['sco', 'Scotland'] },
    ],
    D: [
      {
        group: 'D',
        zhName: '美国',
        enName: 'United States',
        aliases: ['usa', 'United States', 'USA'],
      },
      { group: 'D', zhName: '巴拉圭', enName: 'Paraguay', aliases: ['par', 'Paraguay'] },
      { group: 'D', zhName: '澳大利亚', enName: 'Australia', aliases: ['aus', 'Australia'] },
      {
        group: 'D',
        zhName: '土耳其',
        enName: 'Türkiye',
        aliases: ['tur', 'Türkiye', 'Turkey', 'Turkiye'],
      },
    ],
    E: [
      { group: 'E', zhName: '德国', enName: 'Germany', aliases: ['ger', 'Germany'] },
      { group: 'E', zhName: '库拉索', enName: 'Curaçao', aliases: ['cuw', 'Curaçao', 'Curacao'] },
      {
        group: 'E',
        zhName: '科特迪瓦',
        enName: "Côte d'Ivoire",
        aliases: ['civ', "Côte d'Ivoire", "Cote d'Ivoire", 'Ivory Coast'],
      },
      { group: 'E', zhName: '厄瓜多尔', enName: 'Ecuador', aliases: ['ecu', 'Ecuador'] },
    ],
    F: [
      {
        group: 'F',
        zhName: '荷兰',
        enName: 'Netherlands',
        aliases: ['nld', 'Netherlands', 'Holland'],
      },
      { group: 'F', zhName: '日本', enName: 'Japan', aliases: ['jpn', 'Japan'] },
      { group: 'F', zhName: '瑞典', enName: 'Sweden', aliases: ['swe', 'Sweden'] },
      { group: 'F', zhName: '突尼斯', enName: 'Tunisia', aliases: ['tun', 'Tunisia'] },
    ],
    G: [
      { group: 'G', zhName: '比利时', enName: 'Belgium', aliases: ['bel', 'Belgium'] },
      { group: 'G', zhName: '埃及', enName: 'Egypt', aliases: ['egy', 'Egypt'] },
      { group: 'G', zhName: '伊朗', enName: 'IR Iran', aliases: ['irn', 'IR Iran', 'Iran'] },
      { group: 'G', zhName: '新西兰', enName: 'New Zealand', aliases: ['nzl', 'New Zealand'] },
    ],
    H: [
      { group: 'H', zhName: '西班牙', enName: 'Spain', aliases: ['esp', 'Spain'] },
      {
        group: 'H',
        zhName: '佛得角',
        enName: 'Cabo Verde',
        aliases: ['cvi', 'Cabo Verde', 'Cape Verde'],
      },
      {
        group: 'H',
        zhName: '沙特阿拉伯',
        enName: 'Saudi Arabia',
        aliases: ['ksa', 'Saudi Arabia', 'Saudi'],
      },
      { group: 'H', zhName: '乌拉圭', enName: 'Uruguay', aliases: ['ury', 'Uruguay'] },
    ],
    I: [
      { group: 'I', zhName: '法国', enName: 'France', aliases: ['fra', 'France'] },
      { group: 'I', zhName: '塞内加尔', enName: 'Senegal', aliases: ['sen', 'Senegal'] },
      { group: 'I', zhName: '伊拉克', enName: 'Iraq', aliases: ['irq', 'Iraq'] },
      { group: 'I', zhName: '挪威', enName: 'Norway', aliases: ['nor', 'Norway'] },
    ],
    J: [
      { group: 'J', zhName: '阿根廷', enName: 'Argentina', aliases: ['arg', 'Argentina'] },
      { group: 'J', zhName: '阿尔及利亚', enName: 'Algeria', aliases: ['alg', 'Algeria'] },
      { group: 'J', zhName: '奥地利', enName: 'Austria', aliases: ['aut', 'Austria'] },
      { group: 'J', zhName: '约旦', enName: 'Jordan', aliases: ['jor', 'Jordan'] },
    ],
    K: [
      { group: 'K', zhName: '葡萄牙', enName: 'Portugal', aliases: ['prt', 'Portugal'] },
      {
        group: 'K',
        zhName: '民主刚果',
        enName: 'DR Congo',
        aliases: ['cdr', 'DR Congo', 'Democratic Republic of the Congo', 'Congo DR'],
      },
      { group: 'K', zhName: '乌兹别克斯坦', enName: 'Uzbekistan', aliases: ['uzb', 'Uzbekistan'] },
      { group: 'K', zhName: '哥伦比亚', enName: 'Colombia', aliases: ['col', 'Colombia'] },
    ],
    L: [
      { group: 'L', zhName: '英格兰', enName: 'England', aliases: ['eng', 'England'] },
      { group: 'L', zhName: '克罗地亚', enName: 'Croatia', aliases: ['hrv', 'Croatia'] },
      { group: 'L', zhName: '加纳', enName: 'Ghana', aliases: ['gha', 'Ghana'] },
      { group: 'L', zhName: '巴拿马', enName: 'Panama', aliases: ['pan', 'Panama'] },
    ],
  };

// ---------------------------------------------------------------------------
// Supported sportsbook affiliates (subset of wc_worldcup_affiliate)
// Only these three are displayed in the UI. Extend here if more are needed.
// ---------------------------------------------------------------------------

export interface WcAffiliate {
  affiliate_id: number;
  affiliate_name: string;
}

export const WC_AFFILIATES: WcAffiliate[] = [
  { affiliate_id: 22, affiliate_name: 'BetMGM' },
  { affiliate_id: 23, affiliate_name: 'FanDuel' },
  { affiliate_id: 19, affiliate_name: 'DraftKings' },
];

/** Set of affiliate IDs for fast membership check */
export const WC_AFFILIATE_IDS = new Set(WC_AFFILIATES.map((a) => a.affiliate_id));

/** Map from affiliate_id → display name */
export const WC_AFFILIATE_NAME: Record<number, string> = Object.fromEntries(
  WC_AFFILIATES.map((a) => [a.affiliate_id, a.affiliate_name]),
);

function normalizeTeamKey(value: string): string {
  return value.trim().toLowerCase();
}

export const WORLD_CUP_2026_TEAM_GROUP_MAP: Record<string, WorldCup2026GroupKey> = Object.values(
  WORLD_CUP_2026_GROUP_TEAMS,
).reduce<Record<string, WorldCup2026GroupKey>>((acc, teams) => {
  teams.forEach((team) => {
    [team.zhName, team.enName, ...team.aliases].forEach((name) => {
      acc[normalizeTeamKey(name)] = team.group;
    });
  });
  return acc;
}, {});

export function getWorldCup2026TeamGroup(
  teamNameOrCode?: string | null,
): WorldCup2026GroupKey | undefined {
  if (!teamNameOrCode) return undefined;
  return WORLD_CUP_2026_TEAM_GROUP_MAP[normalizeTeamKey(teamNameOrCode)];
}

export function getWorldCup2026GroupLabel(teamNameOrCode?: string | null): string | undefined {
  const group = getWorldCup2026TeamGroup(teamNameOrCode);
  return group ? `Group ${group}` : undefined;
}
